import { apiInterceptor } from 'utils/apiInterceptor';
export async function ImportSpeaker(inputs, projectId) {
    // Will change this
    const formData = new FormData();

    Object.keys(inputs).forEach((property) => {
        if (Object.prototype.hasOwnProperty.call(inputs, property)) {
            formData.append(property, inputs[property]);
        }
    });

    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers/import?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
            },
            body: formData,
        }
    );

    return await response.json();
}
export async function downloadSampleSpeakers(projectId) {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/speakers/demo-csv?projectId=${projectId}`,
        {
            headers: {
            },
        }
    );

    return await response.text();
}
